import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="lightgreencontentbg keyquestionpadnew">
                                                <div className="paraspace"><p><span
                                                    className="green brownbold">Example two</span></p></div>
                                                <p>We assume someone’s home is a house or flat but people
                                                    can live in all kinds of places.
                                                    Think of where it’s essential a light is kept on all the
                                                    time and failure to do so would
                                                    endanger lives.</p>
                                                <div className="uiheading"><p><span
                                                    className="green brownbold">Tip:</span> When thinking
                                                    laterally, focus on the facts and how they could be
                                                    construed in
                                                    different ways.</p></div>
                                            </div>

                                            <div className="lightgreencontentbg keyquestionpadnew">
                                                <div className="paraspace"><p><span
                                                    className="green brownbold">Example three</span></p>
                                                </div>
                                                <p>For this example, think how things can be used for other
                                                    than their usual purpose.</p>
                                                <div className="uiheading"><p><span
                                                    className="green brownbold">Tip:</span> When thinking
                                                    laterally, try to think of as many different uses for
                                                    things as possible.</p></div>
                                            </div>

                                            <div className="lightgreencontentbg keyquestionpadnew">
                                                <div className="paraspace"><p><span
                                                    className="green brownbold">Example four</span></p>
                                                </div>
                                                <p>This is about semantics. When we read about a fast
                                                    flowing river and the car sinking,
                                                    we assume the river’s deep. The words ‘high speed’ and
                                                    ‘crashed’ make us think this is a
                                                    very dangerous situation.</p>
                                                <div className="uiheading"><p><span
                                                    className="green brownbold">Tip:</span> When thinking
                                                    laterally, challenge what at first seems obvious.</p>
                                                </div>
                                            </div>
                                            <p></p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/>THINKING STYLES</span></div>
                                            <div className="border_subtitle">Challenging vs. accepting</div>
                                            <p>Of course, we all make assumptions all the time – things
                                                would get very tedious if we didn’t
                                                assume, say, that the kettle will turn itself off, as usual.
                                                However, we also make assumptions
                                                because we often have to make quick decisions without much
                                                information, so we make a ‘best fit’
                                                from the available facts – and our own previous
                                                experience.</p>
                                            <p>In other words, rather than relying on the facts alone, our
                                                brains reduce processing time
                                                by referring to previous, similar situations or other
                                                related information. This is how we decide to
                                                react in certain situations, too, but it’s also how we
                                                reinforce prejudice and bias – how we train
                                                ourselves to think in the same way about things all the
                                                time. Challenging our assumption that
                                                carpenters, lorry drivers and mechanics are always men, for
                                                example, makes for more objective
                                                decision making.</p>
                                            <div className="border_subtitle">Logical vs. intuitive
                                                thinking
                                            </div>
                                            <p>Lateral thinking can involve logic, intuition and
                                                imagination. Had you come across pieces of coal,
                                                a carrot and scarf lying on the ground, as in example three
                                                above, your intuition might suggest it
                                                was all that was left of a snowman, and logic would explain
                                                why the snowman himself was no
                                                longer evident, having melted!
                                            </p>
                                            <div className="border_subtitle">Creative vs. literal thinking
                                            </div>
                                            <p>Thinking too literally can inhibit lateral thinking because
                                                it prevents you thinking beyond the
                                                obvious. Many of us assume (there it is, again!) that we’re
                                                not creative, but you’ll surprise yourself
                                                if you let your imagination off the hook for a few minutes
                                                with this short exercise:</p>

                                            <div className="border_subtitle">For two minutes, think of all
                                                the things you could do with a cardboard tube!:
                                            </div>
                                            <p>Here’s a couple: you could cut it up and use it to support
                                                small plants or balance it on two blocks
                                                to use as a hurdle. Try to come up with workable ideas (for
                                                example, it wouldn’t be much use as
                                                a fire poker, would it?)</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}